import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=ee628d34&scoped=true&"
var script = {}
import style0 from "./bottom.vue?vue&type=style&index=0&id=ee628d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee628d34",
  null
  
)

export default component.exports